import { jwtDecode } from "jwt-decode";

interface JWTPayload {
  permissions?: string[];
  permission?: string | string[];
  scope?: string;
  [key: string]: unknown;
}

export const decodeToken = (token: string): JWTPayload | null => {
  try {
    return jwtDecode<JWTPayload>(token);
  } catch (error) {
    console.error("Failed to decode token:", error);
    return null;
  }
};

export const extractPermissionsFromToken = (token: string): string[] => {
  const decoded = decodeToken(token);

  if (!decoded) return [];

  if (decoded.permission) {
    // Can be a single string or array of strings
    if (Array.isArray(decoded.permission)) {
      return decoded.permission;
    }
    return [decoded.permission];
  }

  return [];
};

// JWT issued by the .NET backend uses the canonical Microsoft URI for role
// claims (ClaimTypes.Role). When there's only one role the claim is a string;
// when there are multiple, jwt serializes it as an array.
const ROLE_CLAIM = "http://schemas.microsoft.com/ws/2008/06/identity/claims/role";

export const extractRolesFromToken = (token: string): string[] => {
  const decoded = decodeToken(token);
  if (!decoded) return [];

  const claim = decoded[ROLE_CLAIM] ?? decoded.role ?? decoded.roles;
  if (!claim) return [];
  if (typeof claim === "string") return [claim];
  return Array.isArray(claim)
    ? claim.filter((role): role is string => typeof role === "string")
    : [];
};
